import { TelasIds } from "../../../../../common/utils/tela_ids";
import { IDeleteColetaPrecoUseCase } from "../../../presentation/useCases/delete/delete_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteColetaPrecoUseCase
 */

export class DeleteColetaPrecoUseCase implements IDeleteColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteColetaPreco(
    idTela: TelasIds,
    idColetaPreco: number,
  ): Promise<void> {
    await this.repository.deleteColetaPreco(
      idTela,
      idColetaPreco,
    );
  }
}
